<div class="flex flex-col h-full">
  <div class="panel-header">
    <h2><fa-icon [icon]="headerIcon()" /> {{ headerTitle() }}</h2>
    <button class="panel-close" (click)="close()">×</button>
  </div>
  

  <ng-content></ng-content>

</div>